import commonText from "./commonContents";

export default {
  ...commonText,
  mobileValidityErrorText: "Please provide a valid mobile number to proceed.",
  backButtonText: "Back",
  heading: "Fasttrack - Online Check-in",
  subHeading: "Fasttrack to your new home",
  fasttrackCompletedTextOne:
    "Your fasttrack application has been successfully completed.",
  fasttrackCompletedTextTwo:
    "We are all set to make your buying journey smooth and personalized.",
  fasttrackCompletedTextThree:
    "Questions? Reach out to us at 800-Aldar (25327)",
  fasttrackIncompleteText: "Your fasttrack has not been completed",
  opportunityIdPrefix:
    "On the day of visit, please refer to the appointment number ",
  retryText: "Could you please try again.",
  invalidLeadError: "Booking Online Check-in is invalid",
  suggestionTextInvalidLead: "Please contact Aldar",
  suggestionTextValidLead: "Aldar will contact you soon",
  fastTrackError:
    "An error occured could you please try again by validating the information you have provided.",
  alreadyConvertedLead:
    "The link that your trying to access seems to be used already. Please check your email for the acknowledgment.",
  mandatoryDocumentsNotUploadedError: "Please upload mandatory documents",
  residentStatusYesLabel: "Yes, I am.",
  residentStatusNoLabel: "No, I am not.",
  documentUploadCancelButtonText: "Cancel",
  valueLessThanPrefix: "Value must be less than",
  valueGreaterThanPrefix: "Value must be greater than",
  "Fast Track reference is invalid. Please click on the email link to proceed.":
    "Fasttrack reference is invalid. Please click on the email link to proceed.",
  "Your Fast Track has already been submitted successfully.":
    "Your Fasttrack has already been submitted successfully.",
  docusignDoneStatus:
    "Now that you have signed your documents, you can submit your request.",
  documentStepWarning:
    "Please double-check the information you've provided. Once you move on to the next step, edits will not be possible. Click the 'confirm' button below to continue or 'close' if you need to exit.",
  continueButtonText: "Confirm",
  tabs: {
    idVerification: {
      id: "0",
      tabLabel: "",
      iconUrl: "/du_incomplete.png",
      heading: "",
      subHeadingPart1: "",
      subHeadingPart1PostText: "",
      continueButtonText: "Next",
    },
    personDetails: {
      id: "1",
      tabLabel: "Personal Details",
      iconUrl: "/pmdf_complete.png",
      heading: "Personal Details",
      subHeadingPart1: "To proceed to the next stage, first enter your ",
      subHeadingPart1PostText: "personal information,",
      subHeadingPart2: "save it, and then provide your ",
      subHeadingPart2PostText: "address details",
      fields: {
        FirstName: {
          type: "text",
          label: "First Name",
          requiredErrorMessage: commonText.requiredErrorMessage,
          disabled: true,
          condition: "isNameEditable",
          valueKey: "FirstName",
          maxLength: 40,
        },
        LastName: {
          type: "text",
          label: "Last Name",
          requiredErrorMessage: commonText.requiredErrorMessage,
          disabled: true,
          condition: "isNameEditable",
          valueKey: "LastName",
          maxLength: 80,
        },
        Placeofbirth__c: {
          type: "text",
          label: "Place of Birth",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "Placeofbirth__c",
          maxLength: 40,
        },
        PersonBirthdate: {
          type: "date",
          label: "Date of Birth",
          requiredErrorMessage: commonText.requiredErrorMessage,
          validationCheckOperator: "<",
          validationCheckOperand: "currentDate",
          valueKey: "PersonBirthdate",
          validationChecks: [
            {
              validationCheckOperator: "<",
              validationCheckOperand: "currentDate",
              validationCheckOperandLabel: "current date",
            },
          ],
        },
        Gender__pc: {
          type: "select",
          label: "Gender",
          optionsSource: "gender",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "Gender__pc",
        },
        MaritalStatus__pc: {
          type: "select",
          label: "Marital Status",
          optionsSource: "maritalStatus",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "MaritalStatus__pc",
        },
        MobileCountryCode__pc: {
          type: "select",
          label: "",
          optionsSource: "mobileCountryCode",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "MobileCountryCode__pc",
        },
        MobilePhone__pc: {
          type: "text",
          label: "Mobile Phone",
          format: "number",
          formatErrorMessage: commonText.formatErrorMessage,
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "MobilePhone__pc",
          maxLength: 30,
        },
        PersonEmail: {
          type: "text",
          label: "Email",
          format: "email",
          requiredErrorMessage: commonText.requiredErrorMessage,
          formatErrorMessage: commonText.formatErrorMessage,
          disabled: true,
          valueKey: "PersonEmail",
          maxLength: 80,
        },
        Nationality__pc: {
          type: "select",
          label: "Nationality",
          optionsSource: "nationality",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "Nationality__pc",
        },
        ResidentStatus__pc: {
          type: "radio",
          label: "Are you a resident of the UAE?",
          optionsSource: "residentStatus",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "ResidentStatus__pc",
        },
        NationalIdNumber__pc: {
          type: "text",
          label: "Emirates Id",
          format: "number",
          dependency: "ResidentStatus__pc",
          requiredCondition: "Resident",
          formatErrorMessage: commonText.formatErrorMessage,
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "NationalIdNumber__pc",
          minLength: 15,
          maxLength: 16,
        },
        NationalIdExpiryDate__pc: {
          type: "date",
          label: "Emirates Id Expiry Date",
          dependency: "ResidentStatus__pc",
          requiredCondition: "Resident",
          requiredErrorMessage: commonText.requiredErrorMessage,
          validationCheckOperator: ">",
          validationCheckOperand: "currentDate",
          valueKey: "NationalIdExpiryDate__pc",
          validationChecks: [
            {
              validationCheckOperator: ">",
              validationCheckOperand: "currentDate",
              validationCheckOperandLabel: "current date",
            },
            {
              validationCheckOperator: ">",
              validationCheckOperand: "PersonBirthdate",
              validationCheckOperandLabel: "person birthdate",
            },
          ],
        },
        PassportType__pc: {
          type: "text",
          label: "Passport Type",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "PassportType__pc",
          maxLength: 20,
        },
        PlaceofIssue__pc: {
          type: "text",
          label: "Passport Issue Place",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "PlaceofIssue__pc",
          maxLength: 40,
        },
        PassportIssueDate__pc: {
          type: "date",
          label: "Passport Issue Date",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "PassportIssueDate__pc",
          validationChecks: [
            {
              validationCheckOperator: "<",
              validationCheckOperand: "PassportExpiryDate__pc",
              validationCheckOperandLabel: "passport expiry date",
            },
            {
              validationCheckOperator: "<",
              validationCheckOperand: "currentDate",
              validationCheckOperandLabel: "current date",
            },
            {
              validationCheckOperator: ">",
              validationCheckOperand: "PersonBirthdate",
              validationCheckOperandLabel: "person birthdate",
            },
          ],
        },

        PassportExpiryDate__pc: {
          type: "date",
          label: "Passport Expiry Date",
          requiredErrorMessage: commonText.requiredErrorMessage,
          validationCheckOperator: ">",
          validationCheckOperand: "passportIssueDate",
          valueKey: "PassportExpiryDate__pc",
          validationChecks: [
            {
              validationCheckOperator: ">",
              validationCheckOperand: "PassportIssueDate__pc",
              validationCheckOperandLabel: "passport issue date",
            },
            {
              validationCheckOperator: ">",
              validationCheckOperand: "currentDate",
              validationCheckOperandLabel: "current date",
            },
            {
              validationCheckOperator: ">",
              validationCheckOperand: "PersonBirthdate",
              validationCheckOperandLabel: "person birthdate",
            },
          ],
        },
        PassportNumber__pc: {
          type: "text",
          label: "Passport Number",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "PassportNumber__pc",
          format: "alphaNum",
          maxLength: 20,
        },
        CountryOfResidence__pc: {
          type: "select",
          label: "Country of Residence",
          optionsSource: "country",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "CountryOfResidence__pc",
          dependency: "ResidentStatus__pc",
          requiredCondition: "Non-Resident",
        },
      },
      continueButtonText: "Next",
    },
    addressDetails: {
      id: "2",
      tabLabel: "Address Details",
      iconUrl: "/adf_incomplete.png",
      heading: "Address Details",
      subHeadingPart1:
        "To proceed to the next stage stage, you must first fill in your ",
      subHeadingPart1PostText: "Address details, ",
      subHeadingPart2: "save it, and then proceed to input your ",
      subHeadingPart2PostText: "Wealth details",
      ResidentialAddressSameAsPermanent__cYes: "Yes",
      ResidentialAddressSameAsPermanent__cNo: "No",
      fields: {
        BillingAddressHeading: {
          type: "label",
          label: "Permanent Address Details",
          optional: true,
        },
        BillingCountry: {
          type: "select",
          label: "Country",
          optionsSource: "country", // billingCountry
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "BillingCountry",
        },
        BillingState: {
          type: "select",
          label: "State/Province",
          requiredErrorMessage: commonText.requiredErrorMessage, //billingState
          valueKey: "BillingState",
          optionsSource: "state",
          optional: true,
        },
        BillingStreet: {
          type: "text",
          label: "Address Line 1",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "BillingStreet",
          maxLength: 255,
        },
        BillingCity: {
          type: "text",
          label: "Address Line 2",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "BillingCity",
          maxLength: 40,
        },
        BillingPostalCode: {
          type: "text",
          label: "Postal Code",
          formatErrorMessage: commonText.formatErrorMessage,
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "BillingPostalCode",
          optional: true,
          format: "alphaNum",
          maxLength: 20,
        },
        ResidentialAddressSameAsPermanent__c: {
          type: "radio",
          label:
            "Is the residential address the same as the permanent address?",
          optionsSource: ["Yes", "No"],
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "ResidentialAddressSameAsPermanent__c",
        },
        ShippingAddressHeading: {
          type: "label",
          optional: true,
          label: "Residential Address Details",
          dependency: "ResidentialAddressSameAsPermanent__c",
          requiredCondition: "No",
        },
        ShippingCountry: {
          type: "select",
          label: "Country",
          dependency: "ResidentialAddressSameAsPermanent__c",
          requiredCondition: "No",
          optionsSource: "country", // ShippingCountry
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "ShippingCountry",
        },
        ShippingState: {
          type: "select",
          label: "State/Province",
          dependency: "ResidentialAddressSameAsPermanent__c",
          requiredCondition: "No",
          requiredErrorMessage: commonText.requiredErrorMessage, //ShippingState
          valueKey: "ShippingState",
          optionsSource: "state",
          optional: true,
        },
        ShippingStreet: {
          type: "text",
          label: "Address Line 1",
          dependency: "ResidentialAddressSameAsPermanent__c",
          requiredCondition: "No",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "ShippingStreet",
          maxLength: 255,
        },
        ShippingCity: {
          type: "text",
          label: "Address Line 2",
          dependency: "ResidentialAddressSameAsPermanent__c",
          requiredCondition: "No",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "ShippingCity",
          maxLength: 40,
        },
        ShippingPostalCode: {
          type: "text",
          label: "Postal Code",
          dependency: "ResidentialAddressSameAsPermanent__c",
          requiredCondition: "No",
          formatErrorMessage: commonText.formatErrorMessage,
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "ShippingPostalCode",
          optional: true,
          format: "alphaNum",
          maxLength: 20,
        },
      },
      continueButtonText: "Next",
    },
    employmentDetails: {
      id: "3",
      tabLabel: "Wealth Details",
      iconUrl: "/edf_incomplete.png",
      heading: "Wealth Details",
      subHeadingPart1:
        "To proceed to the next stage, you must first fill in your ",
      subHeadingPart1PostText: "Wealth Details, ",
      subHeadingPart2: "save it, and then proceed to ",
      subHeadingPart2PostText: "upload your documents",
      fields: {
        EmploymentStatus__pc: {
          type: "select",
          label: "Employment",
          optionsSource: "employmentStatus",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "EmploymentStatus__pc",
        },
        Company__pc: {
          type: "text",
          label: "Company Name",
          dependency: "EmploymentStatus__pc",
          requiredCondition: "Employed|Self Employed|Investor|Retired",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "Company__pc",
          maxLength: 60,
        },
        Position__pc: {
          type: "text",
          label: "Position",
          dependency: "EmploymentStatus__pc",
          requiredCondition: "Employed|Self Employed|Investor|Retired",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "Position__pc",
          maxLength: 100,
        },
        CompanyAddress__pc: {
          type: "text",
          label: "Company Address",
          dependency: "EmploymentStatus__pc",
          requiredCondition: "Employed|Self Employed|Investor|Retired",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "CompanyAddress__pc",
          maxLength: 255,
        },
        AnnualIncome__pc: {
          type: "text",
          label: "Annual Income",
          dependency: "EmploymentStatus__pc",
          requiredCondition:
            "Employed|Self Employed|Investor|Inheritance|Retired|Unemployed|House-Wife",
          secondaryDependency: "SourceofFunds__pc",
          secondaryRequiredCondition:
            "Unemployed.Savings/Retirement Income|House-Wife.Savings/Retirement Income",
          formatErrorMessage: commonText.formatErrorMessage,
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "AnnualIncome__pc",
          format: "number",
          maxLength: 16,
        },
        NoofYearswithCompany__pc: {
          type: "text",
          label: "Number of Years with Company",
          dependency: "EmploymentStatus__pc",
          requiredCondition: "Employed|Self Employed|Investor|Retired",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "NoofYearswithCompany__pc",
          formatErrorMessage: commonText.formatErrorMessage,
          format: "number",
          maxLength: 2,
        },
        Industry: {
          type: "select",
          label: "Industry",
          dependency: "EmploymentStatus__pc",
          requiredCondition: "Employed|Self Employed|Investor|Retired",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "Industry",
          optionsSource: "industry",
        },
        SourceofFunds__pc: {
          type: "select",
          label: "Source of Funds",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "SourceofFunds__pc",
          optionsSource: "sourceofFunds",
        },
        AdditionalFieldsHeading: {
          type: "label",
          optional: true,
          label: "Additional Information",
        },
        CustomerBankName__c: {
          type: "text",
          label: "Bank Name for Funds",
          dependency: "EmploymentStatus__pc",
          requiredCondition:
            "Employed|Self Employed|Investor|Inheritance|Retired|Unemployed|House-Wife",
          secondaryDependency: "SourceofFunds__pc",
          secondaryRequiredCondition:
            "Unemployed.Savings/Retirement Income|House-Wife.Savings/Retirement Income",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "CustomerBankName__c",
          formatErrorMessage: commonText.formatErrorMessage,
          maxLength: 255,
        },
        CustomerBankCountry__c: {
          type: "select",
          label: "Bank Country",
          optionsSource: "country",
          dependency: "EmploymentStatus__pc",
          requiredCondition:
            "Employed|Self Employed|Investor|Inheritance|Retired|Unemployed|House-Wife",
          secondaryDependency: "SourceofFunds__pc",
          secondaryRequiredCondition:
            "Unemployed.Savings/Retirement Income|House-Wife.Savings/Retirement Income",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "CustomerBankCountry__c",
        },
        NumberOfUnits__c: {
          type: "text",
          label: "Number of Units",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "NumberOfUnits__c",
          formatErrorMessage: commonText.formatErrorMessage,
          format: "number",
          maxLength: 2,
        },
        EstimatedPurchaseValue__c: {
          type: "text",
          label: "Estimated Purchase Value",
          requiredErrorMessage: commonText.requiredErrorMessage,
          valueKey: "EstimatedPurchaseValue__c",
          formatErrorMessage: commonText.formatErrorMessage,
          format: "number",
          maxLength: 16,
        },
      },

      continueButtonText: "Next",
    },
    uploadDocuments: {
      id: "4",
      tabLabel: "Upload Documents",
      iconUrl: "/du_incomplete.png",
      heading: "Upload Documents",
      subHeadingPart1:
        "To move on to the following stage, you must first upload",
      subHeadingPart1PostText: " your documents",
      subHeadingPart2: ", then proceed to complete the ",
      subHeadingPart2PostText: "required document signing.",

      documents: {
        label: "Attach the following documents",
        exclusionList: [
          "KYC Form",
          "Signed KYC Form",
          "Wealth Form",
          "Signed Wealth Form",
          "ICA Verification",
        ],
        labelMapping: {
          "ICA Verification": "ICA Verification",
          "KYC Form": "KYC Form",
          "National ID Back Copy": "National ID Back Copy",
          "National ID Front Copy": "National ID Front Copy",
          Others: "Others",
          "Passport Copy": "Passport Copy",
          "Salary Certificate": "Salary Certificate",
          "Signed KYC Form": "Signed KYC Form",
          "VISA Copy": "VISA Copy",
          "Trade License": "Trade License",
        },
      },
      mandatoryDocuments: {
        "National ID Back Copy": {
          label: "National ID Back Copy",
          dependency: "ResidentStatus__pc",
          dependancyValue: "Resident",
        },
        "National ID Front Copy": {
          label: "National ID Front Copy",
          dependency: "ResidentStatus__pc",
          dependancyValue: "Resident",
        },
        "Passport Copy": {
          label: "Passport Copy",
        },
        "VISA Copy": {
          label: "VISA Copy",
          dependency: "ResidentStatus__pc",
          dependancyValue: "Resident",
          negativeDependency: "Nationality__pc",
          negativeDependencyValue: "United Arab Emirates",
        },
        "Trade License": {
          label: "Trade License",
          dependency: "EmploymentStatus__pc",
          dependancyValue: "Self Employed",
        },
      },
      continueButtonText: "Next",
    },
    wealthDetails: {
      investorDocument: {
        title: "Investor Document",
        description:
          "Please upload a document that verifies your investor status",
        requiredError:
          "Investor document is required. Please upload a document to verify your investor status.",
      },
      freelancerDocument: {
        title: "Freelancer Document",
        description:
          "Please upload a document that verifies your freelancer status",
        requiredError:
          "freelancer document is required. Please upload a document to verify your freelancer status.",
      },
      otherSourceRequired:{
        otherSourceRequired:"Please select at least one source of funds."
      }
    },
    livenessCheck: {
      id: "5",
      tabLabel: "",
      iconUrl: "/du_incomplete.png",
      heading: "",
      subHeadingPart1: "",
      subHeadingPart1PostText: "",
      continueButtonText: "Next",
    },
    signDocuments: {
      id: "6",
      tabLabel: "Sign Documents",
      iconUrl: "/sdf_incomplete.png",
      heading: "Sign Documents",
      subHeadingPart1: "In order to proceed, it is necessary for you to ",
      subHeadingPart1PostText: "verify and sign your documents.",
      continueButtonText: "Next",
    },
  },
  documentUpload: {
    addDocuments: "Upload Document",
    uploading: "Uploading...",
    loading: "Loading...",
    uploadSuccess: "Document uploaded successfully",
    uploadFailed: "Upload failed. Please try again.",
    dropActive: "Drop files here...",
    invalidFileType: "Invalid file type. Allowed: {formats}",
    fileSizeExceeded: "File size exceeds {size}MB limit.",
    maxDocumentsExceeded: "Maximum {count} documents allowed",
  },
};
